
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { Timeline } from "vue2vis";
import "vue2vis/dist/vue2vis.css";

import UiButton from "@/components/button/ui-button.vue";

import { TimelineGroup, TimelineItem } from "vis";
import TimelineOptionsWithTemplates from "@/entities/scheduler/TimelineOptionsWithTemplates";
import { User } from "@/generated/graphql";
import Roles from "@/entities/Roles";
import RangeChangedPayload from "@/entities/scheduler/RangeChangedPayload";
import slotWrapperElement from "@/helpers/scheduler/timelineSlotHelper";

@Component({
  components: {
    Timeline,
  },
})
export default class Scheduler extends Vue {
  @Prop({ type: Object, required: true }) readonly currentUser!: User;
  @Prop({ type: Array, required: true }) readonly groups!: TimelineGroup[];
  @Prop({ type: Array, required: true }) readonly items!: TimelineItem[];
  @Prop({ type: Array, default: () => [] }) readonly itemsSelection!: any[];
  @Prop({ type: Object, default: () => ({}) }) readonly customOptions!: TimelineOptionsWithTemplates;
  @Prop({ type: String, default: "" }) readonly schedulerView!: string;

  today = new Date(new Date().setHours(0, 0, 0, 0));
  drawn = false;


  defaultOptions: TimelineOptionsWithTemplates = {
    orientation: "top",
    editable: {
      add: true,
      remove: true,
    },
    selectable: true,
    start: this.today,
    showTooltips: true,
    verticalScroll: false,
    horizontalScroll: false,
    zoomable: false,
    margin: {
      item: 3,
      axis: 1
    },
    locale: 'nl',
    zoomMin: 1000 * 60 * 60 * 24 * 0.5,
    zoomMax: 1000 * 60 * 60 * 24 * 31 * 3,
    showCurrentTime: false,
    groupTemplate: (group: TimelineGroup) => {
      return slotWrapperElement(this.$scopedSlots.group, group, "group");
    },
    template: (item: TimelineItem) => {
      return slotWrapperElement(this.$scopedSlots.item, item, "item");
    }
  }

  get isManager(): boolean {
    return this.currentUser.role === Roles.MANAGER && this.schedulerView === "managers";
  }

  get schedulerClasses(): Record<string, boolean> {
    return {
      "groupsHidden": this.isManager,
    }
  }

  get groupsHiddenClass(): string {
    return this.isManager ? "groupsHidden" : "";
  }

  get options(): TimelineOptionsWithTemplates {
    return {
      ...this.defaultOptions,
      ...this.customOptions,
    }
  }

  @Watch("groups")
  redrawGroups(): void {
    (this.$refs.timeline as any).setGroups(this.groups);
  }

  @Watch("items")
  redrawItems(newItems: any, oldItems: any): void {
    (this.$refs.timeline as any).setItems(newItems);
  }

  setSelection(value: string[]): void {
    (this.$refs.timeline as any).setSelection(value);
  }

  setItems(items: any[]): void {
    (this.$refs.timeline as any).setItems(items);
  }

  getEventProperties(event: any) {
    return (this.$refs.timeline as any).getEventProperties(event);
  }

  focus(id: string): void {
    (this.$refs.timeline as any).focus(id);
  }

  on(event: any, callback: any): void {
    return (this.$refs.timeline as any).on(event, callback);
  }

  rangeChanged(e: RangeChangedPayload): void {
    this.$emit("rangechanged", e);
  }

  handleClick(payload: any) {
    this.$emit("click", payload);
  }

  handleSelect(payload: any) {
    this.$emit("select", payload);
  };
}
